import React, { forwardRef } from 'react';
import { ProgressBar, ProgressVariant, ProgressTrack } from './Progress.styles';
import { LayoutProps, MarginProps } from '../../../theme/styledProps';

export interface ProgressProps extends MarginProps, LayoutProps {
  /**
   * Progress percentage (number between 0 and 100).
   */
  value: number;
  variant?: ProgressVariant;
  isVertical?: boolean;
  isLarge?: boolean;
  isFlat?: boolean;
}

export const Progress = forwardRef<HTMLDivElement, ProgressProps>(
  ({ value, variant = 'primary', isVertical, isFlat, ...rest }, ref) => {
    return (
      <ProgressTrack width="100%" isVertical={isVertical} isFlat={isFlat} {...rest}>
        <ProgressBar
          ref={ref}
          value={value}
          variant={variant}
          isVertical={isVertical}
          isFlat={isFlat}
        />
      </ProgressTrack>
    );
  },
);
